export default __webpack_public_path__ + "static/media/006-grizzly bear.aaeb8fd2.svg";